import { getAttemptScores } from '../../../utils/examScores';
import React, { useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { db } from '../../../lib/firebase'; // Adjust path to lib
import Spinner from '../../../components/Spinner';
const DownloadReportButton = ({ examId, examTitle, setModal }) => {
    const [isLoading, setIsLoading] = useState(false);
    const db = getFirestore();

    // Function to convert an array of objects into a CSV formatted string
    const convertToCSV = (data) => {
        if (data.length === 0) return '';
        const headers = Object.keys(data[0]);
        const csvRows = [
            headers.join(','), // CSV header row
            ...data.map(row =>
                headers.map(fieldName => JSON.stringify(row[fieldName])).join(',')
            )
        ];
        return csvRows.join('\n');
    };

    // Main function to handle the download process
    const handleDownload = async () => {
        setIsLoading(true);
        try {
            // 1. Fetch all attempts for the given examId
            const attemptsQuery = query(collection(db, "attempts"), where("examId", "==", examId));
            const attemptsSnapshot = await getDocs(attemptsQuery);

            if (attemptsSnapshot.empty) {
                setModal({ show: true, message: 'No student attempts found for this exam yet.' });
                setIsLoading(false);
                return;
            }

            const reportData = [];

            // 2. Process each attempt to gather student info and scores
            for (const attemptDoc of attemptsSnapshot.docs) {
                const attemptData = attemptDoc.data();
                const userId = attemptData.userId;

                // Fetch the user's details (like name and email) from the 'users' collection
                const userRef = doc(db, 'users', userId);
                const userSnap = await getDoc(userRef);
                const userName = userSnap.exists() ? userSnap.data().name : 'Unknown Name';
                const userEmail = userSnap.exists() ? userSnap.data().email : 'Unknown Email';

                const { autoScore, autoTotal, aiScore: descriptiveScore, aiTotal: descriptiveTotal, totalScore, totalPossible, pendingCount } = getAttemptScores(attemptData);

                reportData.push({
                    studentName: userName,
                    studentEmail: userEmail,
                    autoGradedScore: autoScore,
                    autoGradedTotal: autoTotal,
                    descriptiveScore: descriptiveScore,
                    descriptiveTotal: descriptiveTotal,
                    totalScore: totalScore,
                    totalPossible: totalPossible,
                    evaluationStatus: pendingCount ? 'Awaiting review' : 'Graded',
                    submittedAt: attemptData.submittedAt?.toDate().toLocaleString() || 'N/A',
                });
                // --- MODIFICATION END ---
            }

            // 3. Convert the processed data to a CSV string
            const csvString = convertToCSV(reportData);

            // 4. Create a Blob and trigger the download
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                const filename = `${examTitle.replace(/ /g, '_')}_report.csv`;
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

        } catch (error) {
            console.error("Error generating report:", error);
            setModal({ show: true, message: `Failed to generate report: ${error.message}` });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <button
            onClick={handleDownload}
            disabled={isLoading}
            className="bg-blue-500 text-white py-1 px-3 rounded-lg hover:bg-blue-600 text-sm flex items-center gap-2 disabled:bg-blue-300"
        >
            {isLoading ? <Spinner /> : 'Download Report'}
        </button>
    );
};

export default DownloadReportButton;